import { render, staticRenderFns } from "./Entidades.vue?vue&type=template&id=3ab3ec56&scoped=true&"
import script from "./Entidades.vue?vue&type=script&lang=js&"
export * from "./Entidades.vue?vue&type=script&lang=js&"
import style0 from "./Entidades.vue?vue&type=style&index=0&id=3ab3ec56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab3ec56",
  null
  
)

export default component.exports